export default function renameField(array, fromField, toField) {
  return array.map(({ [fromField]: value, ...rest }) => ({
    ...rest,
    [toField]: value,
  }));
}
